import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse, School } from '../types';

const API_URL = '/v2/schools';

class SchoolService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<School>> {
    return axios.get(`${API_URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<School>> {
    return axios.get(API_URL, config);
  }

  static patch(id: number, data: Partial<School>, config?: AxiosRequestConfig): Promise<DataResponse<School>> {
    return axios.patch(`${API_URL}/${id}`, data, config);
  }

  static create(data: School, config?: AxiosRequestConfig): Promise<DataResponse<School>> {
    return axios.post(API_URL, data, config);
  }
}

export { SchoolService };
